import PreviewStylesCss from "../../styles/PreviewStyles.css";
import TableStyles from "../../styles/TableStyles.css";
import CommonStyles from "../../styles/CommonStyles.css";

export const styles = (theme) => ({
  ...PreviewStylesCss,
  ...TableStyles,
  ...CommonStyles,
 

  muListWrap: {
    padding: "10px",
    height: "calc(100% - 351px)",
    overflow: "auto",
    position: "absolute",
    width: "100%",
    top: "0",
    overflowX: "hidden",

  },
  sideBar:{
    height: "100%",
    position: "relative",
    background: "#181818",
  },
  muDetails: {
    width: "80%",
    display: "inline-block",
    verticalAlign: "top",
    fontSize: "0.75em",
    wordBreak:"break-word",
  },
muLabelsBold: {
    fontWeight: "bold",
  },

  muDetailsBold: {
    fontWeight: "bold",
  },
uploadPreview:{
    background:"#1F364D",
    "& .MuiPaper-root":{
      background:"#1F364D",
      "& > div":{
        // background:"red",
      }
    },
    "& .MuiTabs-root":{
      background:"#001E3A",
    },
    "& .MuiGrid-justify-xs-center":{
      width: "100% !important",      
      padding: "5px",
    },
    "& .MuiDropzoneArea-root":{
      background: "#0A2034 !important",
    }
},
muDetailWrap:{
  display: "flex",
  padding: "8px 0",
  borderBottom: "1px solid #325679",
  // background: "#1f364d",
},
 
  uploadSaveButton:{
    padding: "15px 0 10px 0",
    textAlign:"right",
    "& button":{
      marginRight:"0px",
    }
  },

  globaltrackEdit:{
    "& .MuiFormControl-root":{
      border:"none", 
      background: "#00405f",  
      width:"100%",
      "&:focus":{    
        border:"1px green solid",         
    }  
    },
  
   
  },

globalInput: {
  width:"100%",
  padding: "0",
  
  "& input": {
    borderRadius: "5px !important",
    padding: "10px",
     fontSize:"1em",
    margin: "0",
  },
  "&  div": {
    borderRadius: "5px",  
    padding:"0 !important",
    "&:after":{
      borderBottom:"none !important",
    },
    "&:before":{
      borderBottom:"none !important",
    },
     
  },
  "& > div .MuiFormControl-root":{
    background:"#00405f",
    width:"100%",
     
  },
  "& div.MuiAutocomplete-endAdornment":{
    width:"auto !important",
  },
  "& div.MuiCircularProgress-indeterminate":{
    width:"20px !important",
  },
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":{
    borderColor: "#46af22 !important",
  },
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":{
    borderColor: "#46af22 !important",
  },
  "& .MuiChip-root":{
    margin:"3px !important",
    backgroundColor: "#001b33",
    padding: "3px !important",
    "& > span":{    
      whiteSpace: "normal",
      wordBreak: "break-all",
      lineHeight: "12px",
    },
    "&.Mui-focusVisible":{
      backgroundColor: "#446888",
    },
  },
  "&  .MuiAutocomplete-inputRoot": {
    padding:" 2px 9px",
  },
  "&:before":{
    display:"none",
  },
  "&:after":{
    borderBottom:" 2px solid #11a54e",
  }
},




imageAvatar:{
  height:"136px !important",
},
trackEditContainer:{
  position:"relative",
  "& button":{
    position: "absolute",
    right: "-14px",
    top: "6px",
    background: "#000",
  borderRadius: "50%",
  width: "30px",
  height: "30px",
  minWidth: "inherit",
  border:"1px solid #999",
  "& svg":{
    fontSize: "15px",
    color: "#fff",
  },
  "& span":{
    lineHeight: "1",
  }
  },
},
buttonCustomSize: {
  "& svg": {
    fontSize: "16px !important",
  },
},
commonTopButton: {
  padding: "9px",
  height: "32px",
  width: "32px",
  minWidth: "inherit",
  marginTop: "7px",
  marginLeft: "0px",
},
musicOrigin:{
  "& .MuiOutlinedInput-root":{
    padding: "10px !important",
    background: "#00405f",
    "& .MuiSelect-select:focus":{
      background:"none",
    }
  },
},
artworkHolder:{
  position:"relative",
  padding:"0",
  "&:hover > span":{
    display:"inline-block",
  },
    // Added Breakpoints
    [theme.breakpoints.down("sm")]: {
    "& img":{
      width:"100%",
      height:"auto",
    }
    },
    [theme.breakpoints.up("md")]: {
      "& img":{
        width:"100% !important",
        height:"auto !important",
      }
    },
    [theme.breakpoints.up("lg")]: {
      "& img":{
        width:"160px!important",
        height:"160px !important",
      }
    },

     
}
});
